import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import './Home.css';
import labSplashBanner from './Assets/labSplashBanner.jpg';

const Home = () => {
  const { accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const getFirstName = () => {
    if (accounts && accounts.length > 0) {
      return accounts[0].name.split(' ')[0];
    }
    return '';
  };

  const getLastName = () => {
    if (accounts && accounts.length > 0) {
      return accounts[0].name.split(' ').slice(-1).join(' ');
    }
    return '';
  };

  return (
    <div className="home-container">
      {isAuthenticated ? (
        <>
          <div className="banner-container">
            <img src={labSplashBanner} alt="Lab Splash Banner" className="banner-image" />
            <div className="banner-text">
              <span>Welcome, {getFirstName()} {getLastName()}</span>
              <div className="banner-subtext">Stress Engineering Services</div>
            </div>
          </div>
          <div className="description-container">
            <p className="description-text">
              Welcome to the SES LabDB Portal, your go-to platform for managing shipping and receiving operations. This portal simplifies the process of tracking shipments, managing project entries, and handling a variety of lab-related documentation.
            </p>
          </div>
        </>
      ) : (
        <div className="welcome-container">
          <div className="banner-container">
            <img src={labSplashBanner} alt="Lab Splash Banner" className="banner-image" />
            <div className="banner-text">
              Stress Engineering Services
              <div className="banner-subtext">The Right Stuff on Time</div>
            </div>
          </div>
          <p className="welcome-message">To continue, please authenticate yourself using your SES Microsoft Login.</p>
          {/* Add authentication button or logic here */}
        </div>
      )}
    </div>
  );
};

export default Home;
